import { Button } from 'components/buttons/Button';
import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useState } from 'react';
import { useTableActions } from './hooks/useTableActions';
import { useTableColumns } from './hooks/useTableColumns';
import { SubmenuTooltip, MoreButton } from 'components';

import ic_accept_all from "assets/images/ic_accept_all.svg";
import ic_reject_all from "assets/images/ic_reject_all.svg";
import ic_reset_payment_due_date from "assets/images/ic_reset_payment_due_date.svg";
import ic_update_payment_due_date from "assets/images/ic_update_payment_due_date.svg";

import "assets/scss/billingPortal/modules/outletStatusChange.scss";
import useFilters from './hooks/useFilters';
import useOutletsActions from 'dataflow/billingPortal/actions/useOutlet.actions';
import { MultiFilters } from 'components/filters/MultiFilters';
import { convertArrayToDropdownArrayFormat, getTotalCountFromHeader, isArrayNotEmpty, isNumberValid } from 'functions';
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import ic_update_expiry_date from "assets/images/ic_update_expiry_date.svg";
import useModals from './hooks/useModals';
import { Toaster } from 'components/notification/Toaster';

function OutletStatusChange(props) {
    const [currentTabId, setCurrentTabId] = useState("active");
    const [selectedOutlets, setSelectedOutlets] = useState();
    const [isTableRefreshRequired, setIsTableRefreshRequired] = useState();
    const [accountCodeList, setAccountCodeList] = useState([]);
    const [getAccountCodeList_requesting, setGetAccountCodeList_requesting] = useState();
    const [isFilterResetRequired, setIsFilterResetRequired] = useState();

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        getAllOutlets_requesting,
        allOutletList, allOutletListHeaders,

        activateOutlet_requesting, suspendOutlet_requesting,
        deleteOutlet_requesting, revertDeleteOutlet_requesting,
        activateOutlet_isSuccessful, suspendOutlet_isSuccessful,
        deleteOutlet_isSuccessful, revertDeleteOutlet_isSuccessful,
        setSuspendDate_requesting, setSuspendDate_isSuccessful,
        addOutletActivationExclusion_requesting, addOutletActivationExclusion_isSuccessful,
        removeOutletActivationExclusion_requesting, removeOutletActivationExclusion_isSuccessful,
        removeSuspendDate_requesting, removeSuspendDate_isSuccessful,
    } = useCustomSelector("outlet");
    const { getAllOutlets, getFilteredAccountCodeList } = useOutletsActions();

    useEffect(() => {
        setIsTableRefreshRequired(activateOutlet_requesting? false: activateOutlet_isSuccessful);
    }, [activateOutlet_isSuccessful, activateOutlet_requesting]);
    useEffect(() => {
        setIsTableRefreshRequired(suspendOutlet_requesting? false: suspendOutlet_isSuccessful);
    }, [suspendOutlet_isSuccessful, suspendOutlet_requesting]);
    useEffect(() => {
        setIsTableRefreshRequired(deleteOutlet_requesting? false: deleteOutlet_isSuccessful);
    }, [deleteOutlet_isSuccessful, deleteOutlet_requesting]);
    useEffect(() => {
        setIsTableRefreshRequired(revertDeleteOutlet_requesting? false: revertDeleteOutlet_isSuccessful);
    }, [revertDeleteOutlet_isSuccessful, revertDeleteOutlet_requesting]);
    useEffect(() => {
        setIsTableRefreshRequired(setSuspendDate_requesting? false: setSuspendDate_isSuccessful);
    }, [setSuspendDate_requesting, setSuspendDate_isSuccessful]);

    useEffect(() => {
        setIsTableRefreshRequired(addOutletActivationExclusion_requesting? false: addOutletActivationExclusion_isSuccessful);
    }, [addOutletActivationExclusion_isSuccessful, addOutletActivationExclusion_requesting]);
    useEffect(() => {
        setIsTableRefreshRequired(removeOutletActivationExclusion_requesting? false: removeOutletActivationExclusion_isSuccessful);
    }, [removeOutletActivationExclusion_isSuccessful, removeOutletActivationExclusion_requesting]);
    useEffect(() => {
        setIsTableRefreshRequired(removeSuspendDate_requesting? false: removeSuspendDate_isSuccessful);
    }, [removeSuspendDate_isSuccessful, removeSuspendDate_requesting]);

    useEffect(() => {
        setGetAccountCodeList_requesting(true);
        getFilteredAccountCodeList()
            .then((accountCodeList_api) => {
                if (isArrayNotEmpty(accountCodeList_api)) {
                    let accountCodeListSorted = Array.from(new Set(accountCodeList_api)).sort();
                    setAccountCodeList(convertArrayToDropdownArrayFormat(accountCodeListSorted));
                }
                else {
                    setAccountCodeList([]);
                }
            })
            .catch(() => {
                setAccountCodeList([]);
            })
            .finally(() => {
                setGetAccountCodeList_requesting(false);
            });
    }, []);

    useEffect(() => {
        if (isFilterResetRequired) setIsFilterResetRequired(false);
    }, [isFilterResetRequired]);

    const {
        getAllComList_requesting, allComList
    } = useCustomSelector("accountControl");
    const { getAllComList } = useAccountControlActions();
    useEffect(() => {
        getAllComList();
    }, [])

    const {
        updatePaymentDueDate_requesting,
        updatePaymentDueDate_isSuccessful,
        resetPaymentDueDate_requesting,
        resetPaymentDueDate_isSuccessful
    } = useCustomSelector("accountControl");

    useEffect(() => {
        if (updatePaymentDueDate_requesting || resetPaymentDueDate_requesting) {
            setIsTableRefreshRequired(false);
            return;
        }

        if (updatePaymentDueDate_isSuccessful || resetPaymentDueDate_isSuccessful) {
            setIsTableRefreshRequired(true);
        }
    }, [updatePaymentDueDate_requesting, updatePaymentDueDate_isSuccessful, resetPaymentDueDate_requesting, resetPaymentDueDate_isSuccessful]);

    const {
        comId, setComId,
        accountCode, setAccountCode,
        companyName, setCompanyName,

        isFiltering, onFilterSubmit,
    } = useFilters(currentTabId);

    const comIdForQuery = comId ? comId : 0;

    let tabsDetails = [
        {
            id: "active",
            text: "Active",
            filters: {
                isSuspended: false,
                isDeleted: false,
                showOutletActivationExclusion: null,
                comId: comIdForQuery,
                accountCode
            }
        },
        {
            id: "suspended",
            text: "Suspended",
            filters: {
                isSuspended: true,
                isDeleted: false,
                showOutletActivationExclusion: false,
                comId: comIdForQuery,
                accountCode
            }
        },
        {
            id: "activationExcluded",
            text: "Activation Excluded",
            filters: {
                isSuspended: true,
                isDeleted: false,
                showOutletActivationExclusion: true,
                comId: comIdForQuery,
                accountCode
            }
        },
        {
            id: "deleted",
            text: "Deleted",
            filters: {
                isSuspended: null,
                isDeleted: true,
                showOutletActivationExclusion: null,
                comId: comIdForQuery,
                accountCode
            }
        },
    ];

    const {
        updateMultipleOutlets, updateSingleOutlet,
        updatingSingleRowPos,
    } = useTableActions(selectedOutlets);

    const columns = useTableColumns({
        updateSingleOutlet,
        currentTabId,
        updatingSingleRowPos
    });

    const {
        updatePaymentDueDateModal, resetPaymentDueDateModal,
        setSuspendDateModal, setIsVisible_setSuspendDate,
        setIsVisible_updatePaymentDueDate, setIsVisible_resetPaymentDueDate
    } = useModals(selectedOutlets);

    function rowSelectionCheck(callback = () => {}) {
        if (isArrayNotEmpty(selectedOutlets)) {
            callback();
        }
        else {
            Toaster({
                type: "info",
                msg: "Please selected at least 1 row"
            })
        }
    }

    return (
        <div className='outlet-status-change'>
            {/* Payment Due Date Modals */}
            {updatePaymentDueDateModal}
            {resetPaymentDueDateModal}

            {/* Suspend Date Modal */}
            {setSuspendDateModal}

            <DashboardLayout
                headerTitle={"Outlet Status Change"}

                bodyClassName={"outlet-status-change-body"}
                body={(
                    <GeneralTable
                        className={"outlet-status-change__table"}
                        columns={columns}
                        data={userPermissions?.Internal_OutletStatus_View ? allOutletList: []}

                        isTableRefreshRequired={isTableRefreshRequired}

                        getTableData={getAllOutlets}

                        onRowSelectionChange={setSelectedOutlets}

                        outerTableHeader={(outerTableHeader_props) => {
                            const { 
                                filterOptions, setFilterOptions
                            } = outerTableHeader_props;

                            return (
                                <div className={"table__headers"}>
                                    {/* Top Section */}
                                    <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                        {/* Title */}
                                        <div className={"headers__title tableHeaderTitle "}>
                                            List
                                        </div>

                                        <div className={"headers__actions d-flex"}>
                                            {/* Activate */}
                                            {(currentTabId === "trial") || (currentTabId === "suspended")? (
                                                <Button
                                                    className={"actions__activate-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_OutletStatus_Activate)}
                                                    handleOnClick={() => updateMultipleOutlets("activate")}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={!isNumberValid(updatingSingleRowPos.current) && activateOutlet_requesting}
                                                >
                                                    <>
                                                        <img
                                                            className={"activate-all__icon"}
                                                            src={ic_accept_all}
                                                        />

                                                        <span className={"activate-all__text tableHeaderButtonText "}>Activate</span>
                                                    </>
                                                </Button>
                                            ):""}

                                            {/* Move to Activation Excluded */}
                                            {(currentTabId === "suspended")? (
                                                <Button
                                                    className={"actions__suspend-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_OutletStatus_Suspend)}
                                                    handleOnClick={() => updateMultipleOutlets("addActivationExclusion")}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={!isNumberValid(updatingSingleRowPos.current) && addOutletActivationExclusion_requesting}
                                                >
                                                    <>
                                                        <img
                                                            className={"suspend-all__icon"}
                                                            src={ic_reject_all}
                                                        />

                                                        <span className={"suspend-all__text tableHeaderButtonText "}>Move to Activation Excluded</span>
                                                    </>
                                                </Button>
                                            ):""}

                                            {/* Revert */}
                                            {(currentTabId === "deleted")? (
                                                <Button
                                                    className={"actions__activate-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_OutletStatus_Activate)}
                                                    handleOnClick={() => updateMultipleOutlets("revert")}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={!isNumberValid(updatingSingleRowPos.current) && revertDeleteOutlet_requesting}
                                                >
                                                    <>
                                                        <img
                                                            className={"activate-all__icon"}
                                                            src={ic_accept_all}
                                                        />

                                                        <span className={"activate-all__text tableHeaderButtonText "}>Revert</span>
                                                    </>
                                                </Button>
                                            ):""}

                                            {/* Move to Suspended */}
                                            {(currentTabId === "activationExcluded")? (
                                                <Button
                                                    className={"actions__activate-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_OutletStatus_Suspend)}
                                                    handleOnClick={() => updateMultipleOutlets("removeActivationExclusion")}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={!isNumberValid(updatingSingleRowPos.current) && removeOutletActivationExclusion_requesting}
                                                >
                                                    <>
                                                        <img
                                                            className={"activate-all__icon"}
                                                            src={ic_accept_all}
                                                        />

                                                        <span className={"activate-all__text tableHeaderButtonText "}>Move to Suspended</span>
                                                    </>
                                                </Button>
                                            ):""}

                                            {/* Suspend */}
                                            {(currentTabId === "trial") || (currentTabId === "active")? (
                                                <Button
                                                    className={"actions__suspend-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_OutletStatus_Suspend)}
                                                    handleOnClick={() => updateMultipleOutlets("suspend")}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={!isNumberValid(updatingSingleRowPos.current) && suspendOutlet_requesting}
                                                    >
                                                    <>
                                                        <img
                                                            className={"suspend-all__icon"}
                                                            src={ic_reject_all}
                                                        />

                                                        <span className={"suspend-all__text tableHeaderButtonText "}>Suspend</span>
                                                    </>
                                                </Button>
                                            ):""}

                                            {/* Delete */}
                                            {(currentTabId === "active")? (
                                                <Button
                                                    className={"actions__suspend-all  d-flex align-items-center"}
                                                    isDisabled={!(userPermissions?.Internal_OutletStatus_Suspend)}
                                                    handleOnClick={() => updateMultipleOutlets("delete")}
                                                    isSpinnerColorPrimary isDecoration_primaryTransparent
                                                    isLoading={!isNumberValid(updatingSingleRowPos.current) && deleteOutlet_requesting}
                                                >
                                                    <>
                                                        <img
                                                            className={"suspend-all__icon"}
                                                            src={ic_reject_all}
                                                        />

                                                        <span className={"suspend-all__text tableHeaderButtonText "}>Delete</span>
                                                    </>
                                                </Button>
                                            ):""}

                                            <SubmenuTooltip
                                                className={"action__more-actions-wrapper"}
                                                menuItems={[
                                                    {
                                                        icon: ic_update_payment_due_date,
                                                        label: "Update Payment Due",
                                                        isDisabled: !(userPermissions?.Internal_AccControl_PaymentDueUpdate),
                                                        onClick: () => rowSelectionCheck(() => setIsVisible_updatePaymentDueDate(true)),
                                                    },
                                                    {
                                                        icon: ic_reset_payment_due_date,
                                                        label: "Reset Payment Due",
                                                        isDisabled: !(userPermissions?.Internal_AccControl_PaymentDueUpdate),
                                                        onClick: () => rowSelectionCheck(() => setIsVisible_resetPaymentDueDate(true)),
                                                    },
                                                    {
                                                        icon: ic_update_expiry_date,
                                                        label: "Set Suspend Date",
                                                        isDisabled: !(userPermissions?.Internal_OutletStatus_Suspend),
                                                        onClick: () => rowSelectionCheck(() => setIsVisible_setSuspendDate(true)),
                                                    },
                                                    {
                                                        icon: ic_update_expiry_date,
                                                        label: "Remove Suspend Date",
                                                        isHidden: currentTabId !== "active",
                                                        isDisabled: !(userPermissions?.Internal_OutletStatus_Suspend),
                                                        onClick: () => rowSelectionCheck(() => updateMultipleOutlets("removeSuspendDate")),
                                                    },
                                                ]}
                                            >
                                                <MoreButton
                                                    className={"more-actions-wrapper__more-actions"}
                                                    iconClassName={"more-actions__icon"}
                                                />
                                            </SubmenuTooltip>
                                        </div>
                                    </div>

                                    {/* Bottom Section */}
                                    <div className={"headers__bottom-section d-flex"}>
                                        <MultiFilters
                                            defaultFilterOption={{
                                                label: "COM ID", 
                                                propertyName: "comId",
                                                placeholder: "Select COM ID",
                                                options: (isArrayNotEmpty(allComList)) ? allComList.map((obj) => {
                                                    return {
                                                        label: obj?.ComId + " - " + obj?.ComName,
                                                        value: obj?.ComId
                                                    };
                                                }) : [],
                                                inputType: "dropdown",
                                                isDisabled: !(userPermissions?.Internal_OutletStatus_View) || getAllComList_requesting,
                                            }}
                                            filterOptions={[
                                                {
                                                    label: "COM ID", 
                                                    propertyName: "comId",
                                                    placeholder: "Select COM ID",
                                                    options: (isArrayNotEmpty(allComList)) ? allComList.map((obj) => {
                                                        return {
                                                            label: obj?.ComId + " - " + obj?.ComName,
                                                            value: obj?.ComId
                                                        };
                                                    }) : [],
                                                    inputType: "dropdown",
                                                    isDisabled: !(userPermissions?.Internal_OutletStatus_View) || getAllComList_requesting,
                                                },
                                                {
                                                    label: "Account Code", 
                                                    propertyName: "accountCode",
                                                    placeholder: "Select Account Code",
                                                    options: accountCodeList,
                                                    inputType: "dropdown",
                                                    isDisabled: !(userPermissions?.Internal_OutletStatus_View) || getAccountCodeList_requesting
                                                }
                                            ]}
                                            dropdownPlaceholder={"Select Filter"}
                                            onApplyFilter={(inputFilters) => {
                                                let nextComId = inputFilters?.comId ? inputFilters.comId : "";
                                                let nextAccountCode = inputFilters?.accountCode ? inputFilters.accountCode : "";

                                                setComId(nextComId);
                                                setAccountCode(nextAccountCode);

                                                onFilterSubmit(
                                                    setFilterOptions,
                                                    filterOptions,
                                                    false,
                                                    {
                                                        comId: nextComId,
                                                        accountCode: nextAccountCode
                                                    }
                                                );
                                            }}
                                            isResetFromParentRequired={isFilterResetRequired}
                                        />
                                    </div>
                                </div>
                            );
                        }}
                        
                        defaultFilter={{ isSuspended: false, isDeleted: false }}
                        tabsDetails={tabsDetails}
                        onTabIdChange={(tabId) => {
                            setCurrentTabId(tabId);
                        }}
                        defaultTabId={currentTabId}
                        isTabRequired

                        isTableDataLoading={getAllOutlets_requesting}

                        isUsingPagination
                        totalRecords={getTotalCountFromHeader(allOutletListHeaders)}

                        isColumnResizeable
                        isTableOddRowsDarken
                        isCheckboxRequired
                        isCheckboxColumnFirst
                    />
                )}
            />
        </div>
    );
}

export default OutletStatusChange;